import script from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchHistory.vue?vue&type=script&setup=true&lang=js"

import "./SearchHistory.vue?vue&type=style&index=0&id=17b73ba8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b73ba8"]])

export default __exports__